import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const PDRecoveryToken = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [currentRecoveryToken, setCurrentRecoveryToken] = useState('');
  const [newRecoveryToken, setNewRecoveryToken] = useState('');
  const [confirmNewRecoveryToken, setConfirmNewRecoveryToken] = useState('');
  const [buttonClicked, setButtonClicked] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showCurrentRecoveryToken, setShowCurrentRecoveryToken] = useState(false);
  const [showNewRecoveryToken, setShowNewRecoveryToken] = useState(false);
  const [showConfirmNewRecoveryToken, setShowConfirmNewRecoveryToken] = useState(false);


  const handleChangeRecoveryToken = async () => {
    if (currentRecoveryToken.length < 6) {
      setError("Current Recovery Token must be at least 6 characters long.");
      return;
    }
    if (newRecoveryToken.length < 6) {
      setError("New Recovery Token must be at least 8 characters long.");
      return;
    }
    if (newRecoveryToken === currentRecoveryToken) {
      setError("New Recovery Token must be different from the current recoverytoken.");
      return;
    }
    if (newRecoveryToken !== confirmNewRecoveryToken) {
      setError("New Recovery Token and confirm recoverytoken do not match.");
      return;
    }

    setError('');
    setButtonClicked(true);

    const config = {
      url: "/auth/changerecoverytoken",
      method: "post",
      data: { currentToken: currentRecoveryToken, recoveryToken: newRecoveryToken, userId: authState.user._id },
      headers: { Authorization: authState.token }
    };

    fetchData(config)
      .then(response => {
        if (response.status) {
          setSuccess(true);
          // setMessage("Recovery Token Changed Successfully! Please login again.");
          setError("");
          setMessage("Recovery Token Changed Successfully!");
        } else {
          setMessage("Recovery Token not changed! Please try again.");
        }
      })
      .catch(error => {
        setError(
          error?.response?.data?.msg ||
          "Error changing recovery token."
        );
      });
  };

  const toggleCurrentRecoveryTokenVisibility = () => {
    setShowCurrentRecoveryToken(!showCurrentRecoveryToken);
  };

  const toggleNewRecoveryTokenVisibility = () => {
      setShowNewRecoveryToken(!showNewRecoveryToken);
  };

  const toggleConfirmNewRecoveryTokenVisibility = () => {
      setShowConfirmNewRecoveryToken(!showConfirmNewRecoveryToken);
  };

  const handleBackClicked = async () => {
    navigate(-1);
  }

  return (
      <div className="space-y-4 bg-gray-900 p-5 rounded-xl text-white border-t-2 border-cyan-200 mt-2 max-w-2xl flex flex-col justify-center">
        <h2 className="text-lg lg:text-xl text-cyan-200 font-bold text-center mb-6">
          Change Recovery Token
        </h2>
        <div className="flex flex-col gap-2">
          <label className="text-sm">Current Recovery Token</label>
          <div className="relative w-full">
            <input
              type={showCurrentRecoveryToken ? "text" : "password"}
              // style={{width: "150px"}}
              className="w-full h-10 px-3 pr-10 text-sm text-black border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
              value={currentRecoveryToken}
              onChange={(e) => setCurrentRecoveryToken(e.target.value)}
              placeholder="Enter current recoverytoken"
              autoComplete="current-recoverytoken"
            />

            <div
              className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-700"
              onClick={toggleCurrentRecoveryTokenVisibility}
            >
              <FontAwesomeIcon
                icon={showCurrentRecoveryToken ? faEyeSlash : faEye}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-sm">New Recovery Token</label>
          <div className="relative w-full">
            <input
              type={showNewRecoveryToken ? "text" : "password"}
              // style={{width: "150px"}}
              className="w-full h-10 px-3 pr-10 text-sm text-black border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
              value={newRecoveryToken}
              onChange={(e) => setNewRecoveryToken(e.target.value)}
              placeholder="Enter new recoverytoken"
              autoComplete="new-recoverytoken"
            />
            <div
              className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-700"
              onClick={toggleNewRecoveryTokenVisibility}
            >
              <FontAwesomeIcon
                icon={showNewRecoveryToken ? faEyeSlash : faEye}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-sm">Confirm New Recovery Token</label>
          <div className="relative w-full">
            <input
              type={showConfirmNewRecoveryToken ? "text" : "password"}
              // style={{width: "150px"}}
              className="w-full h-10 px-3 pr-10 text-sm text-black border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
              value={confirmNewRecoveryToken}
              onChange={(e) => setConfirmNewRecoveryToken(e.target.value)}
              placeholder="Confirm new recoverytoken"
              autoComplete="new-recoverytoken"
            />
            <div
              className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-700"
              onClick={toggleConfirmNewRecoveryTokenVisibility}
            >
              <FontAwesomeIcon
                icon={showConfirmNewRecoveryToken ? faEyeSlash : faEye}
              />
            </div>
          </div>
        </div>
        {message && <p className="text-green-400 text-sm">{message}</p>}
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <div className="flex justify-center gap-4 pt-2">
          <button
            className="w-fit text-xs px-2 py-1 lg:text-sm bg-blue-600 text-white hover:bg-blue-700"
            onClick={handleChangeRecoveryToken}
            disabled={loading || success} 
          >
            Change Recovery Token
          </button>

          <button
            className="w-fit px-2 py-1 text-xs lg:text-sm bg-blue-600 text-white hover:bg-blue-700"
            onClick={handleBackClicked}
          >
            Back
          </button>
        </div>
      </div>
  );
};

export default PDRecoveryToken;
